import { Group, TextInput, rem } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { useDebouncedCallback } from "use-debounce";
import { useAppTranslation } from "hooks/useTranslation";

interface VenuesSearchFilterProps {
  onUpdateName?: (name: string) => void;
}

export const VenuesSearchFilter = (props: VenuesSearchFilterProps) => {
  const { onUpdateName } = props;
  const { t } = useAppTranslation();

  const debouncedTitle = useDebouncedCallback(
    (value) => {
      onUpdateName && onUpdateName(value);
    },
    // delay in ms
    500
  );

  return (
    <Group>
      <TextInput
        label=""
        placeholder={t("venues.name")}
        leftSection={<IconSearch style={{ width: rem(16), height: rem(16) }} />}
        onChange={(venue) => debouncedTitle(venue.currentTarget.value)}
      />
    </Group>
  );
};
